module.exports = __webpack_public_path__ + "static/media/trial2.d9b84689.mp3";